module.exports = __webpack_public_path__ + "img/blank-intro.ea30f0e3.png";